import TrackPlayerModal from './TrackPlayerModal';

export default TrackPlayerModal;



// WEBPACK FOOTER //
// ./src/app/components/TrackPlayerModal/index.js